import { Link } from "react-router-dom";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

export default function ContactCTA() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-3 md:py-6 px-3 md:px-6 lg:px-8 bg-[#f0efef]">
      <div className="max-w-7xl mx-auto bg-[#025ab0] rounded-[20px] overflow-hidden">
        <div className="p-5 md:p-8 lg:p-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5 md:gap-6">
            <div ref={ref} className={getRevealClass(isVisible)}>
              <div>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-tight mb-1 text-center md:text-left">Contact</h2>
                <p className="text-xs md:text-sm text-white/70 mb-3 text-center md:text-left">お問い合わせ</p>
                <div className="hidden md:block w-8 h-px bg-white mb-5" />
                <p className="md:hidden text-sm text-white/80 leading-relaxed max-w-md mx-auto text-center mb-4">
                  お客様からのお問い合わせをお待ちしております。<br />
                  お気軽にご連絡ください。
                </p>
                <p className="hidden md:block text-sm text-white/80 leading-relaxed max-w-md">
                  お客様からのお問い合わせをお待ちしております。<br />
                  お気軽にご連絡ください。
                </p>
              </div>
            </div>
            <Link
              to="/contact"
              className="shrink-0 inline-flex items-center justify-center gap-3 bg-white text-gray-900 border border-white text-base tracking-widest px-9 md:px-16 py-5 md:py-6 hover:bg-[#025ab0] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap w-full md:w-auto"
            >
              お問い合わせ
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}